import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { PageHeader, ListGroup } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import SaveCollaborator, { saveRow } from './SaveCollaborator';
import MoreEditor from './MoreEditor';
import QS from 'querystring';
import './cms.css';

import { URL_API_COLLABORATOR } from '../Utils';

const headerStyle = {
    textAlign: 'center'
};

const cellEditProp = {
    mode: 'click',
    blurToSave: true
};
 
// For deleteRow row, selection must be enabled.
const selectRowProp = {
    mode: 'checkbox',
    clickToSelect: true,  // click to select, default is false
    clickToExpand: true  // click to expand row, default is false
};

class Collaborator extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            collaborators: [],
            saveStatus: ''
        };
    }

    async componentDidMount() {
        if(this.props.userToken === null) {
            return;
        }

        this.setState({isLoading: true});

        try {
            const results = await this.collaborators();
            this.setState({collaborators: results.data.body});
        }
        catch (e) {
            alert(e);
        }

        this.setState({isLoading: false});
    }

    componentWillReceiveProps(nextProps) {
        if(this.props !== nextProps) {
            this.setState({
                collaborators: this.collaborators()
            });
        }
    }

    onUpdate = (newProps, id) => {
        this.setState( {
            saveStatus: newProps.saveStatus,
            idToUpdate: id
        });
    };

    onAfterDeleteRow = rowKeys => {
        axios.delete(`${URL_API_COLLABORATOR}?id=${rowKeys.join(",")}`);
    };

    onAfterInsertRow = row => {
        const self = this;
        axios.post(`${URL_API_COLLABORATOR}?${QS.stringify(row)}`).then(async response => {
            row.id = response.data.insertId;
            const newCollaborators = await this.collaborators();
            self.setState({
                collaborators: newCollaborators.data.body
            });
        })
    };

    collaborators = () => {
        return axios.get(`${URL_API_COLLABORATOR}`)
    };

    attachFormatter = (cell,row) => {
        return (
            <SaveCollaborator saveStatus={ row.id === this.state.idToUpdate ? this.state.saveStatus : '' } row={ row }/>
        );
    };

    moreFormatter = (cell, row) => {
        return <i className="glyphicon glyphicon-plus"></i>;
    };

    createMoreEditor = (onUpdate, props) => (<MoreEditor onUpdate={ onUpdate } {...props}/>);

    handleChange(e) { /* do nothing for now */ }

    renderCollaboratorsList = (collaborators) => {
        return (
            <div onChange={this.handleChange.bind(this)}>
                <BootstrapTable pagination
                                search
                                insertRow
                                exportCSV
                                deleteRow
                                selectRow={ selectRowProp }
                                options={ { afterInsertRow: this.onAfterInsertRow, afterDeleteRow: this.onAfterDeleteRow } }
                                data={ collaborators }
                                cellEdit={ cellEditProp }
                                striped
                                hover>
                    <TableHeaderColumn isKey dataField='id' width="70" columnTitle autoValue>ID</TableHeaderColumn>
                    <TableHeaderColumn dataField='first' columnTitle>First Name</TableHeaderColumn>
                    <TableHeaderColumn dataField='last' columnTitle>Last Name</TableHeaderColumn>
                    <TableHeaderColumn dataField='email' columnTitle>Email</TableHeaderColumn>
                    <TableHeaderColumn width="40" tdStyle={ { textAlign: 'center' } } dataFormat={ this.moreFormatter } customEditor={ { getElement: this.createMoreEditor, customEditorParameters: { updateCollaborator: this.onUpdate.bind(this) } } }></TableHeaderColumn>
                    <TableHeaderColumn width="100" dataAlign='center' editable={ false }
                                       dataFormat={this.attachFormatter.bind(this)}>
                    </TableHeaderColumn>
                </BootstrapTable>
            </div>
        );
    };

    renderLander = () => {
        return (
            <div className="lander">
                <h1>Bible.In.Its.Traditions - Blog Management Console</h1>
                <div>
                    <Link to="/login" className="btn btn-info btn-lg">Login</Link>
                </div>
            </div>
        );
    };

    renderCollaborators = () => {
        return (
            <div className="title">
                <PageHeader style={headerStyle}>Bible.In.Its.Traditions Collaborators List</PageHeader>
                <ListGroup>
                    {!this.state.isLoading
                    && this.renderCollaboratorsList(this.state.collaborators)}
                </ListGroup>
            </div>
        );
    };

    render() {
        return (
            <div>
                <div className="cms">
                    {this.props.userToken === null
                        ? this.renderLander()
                        : this.renderCollaborators()}
                </div>
            </div>
        );
    }
}

// export default withRouter(Collaborator);
export default Collaborator;



// WEBPACK FOOTER //
// ./src/containers/Collaborator.js